import restaurantInstance from '../instance'

const fetchAreas = (page = 0, size = 0) => {
  return restaurantInstance.get('/areas/?page=' + page + '&size=' + size)
}

export default fetchAreas
